<template>
  <div class="header-cb" v-if="!$route.query.view">
    <div>
      <p><b style="font-size:28px; font-weight: 800;">Robots</b></p>
      <p style="margin-left: 25px; font-size: 16px; color: #666; margin-top: 8px;">ロボ社員一覧・稼働状況</p>
    </div>
    <div>
      <div style="margin-left: 10px;">
        <b-dropdown aria-role="list">
          <button class="button" type="button" slot="trigger">
              <template v-if="!isArchiveList">
                  <b-icon icon="format-list-bulleted-type"></b-icon>
                  <span class="-left-8px">ロボの一覧</span>
              </template>
              <template v-else>
                  <b-icon icon="archive"></b-icon>
                  <span class="-left-8px">アーカイブ</span>
              </template>
              <b-icon icon="menu-down"></b-icon>
          </button>
          <b-dropdown-item @click="changeArchiveList(false)" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="format-list-bulleted-type"></b-icon>
                  <div class="media-content">
                      <h3>ロボ一覧</h3>
                      <small>アーカイブされていないロボの一覧</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="changeArchiveList(true)" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="archive"></b-icon>
                  <div class="media-content">
                      <h3>アーカイブ</h3>
                      <small>アーカイブされているロボの一覧</small>
                  </div>
              </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <input class="input" style="width: 200px; margin-left: 10px;" placeholder="🔎ロボ管理名で検索" @input="searchChatBot" v-model="searchChatBotName"/>
      <!-- <div v-show="isPlan"> -->
      <div>
        <div style="margin-left: 10px;">
          <b-tooltip label="新しいロボを作成する" position="is-bottom">
            <a class="button is-primary" @click="createChatBot()">
              <span class="mdi mdi-plus"></span>ロボを作成
            </a>
          </b-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatBotHeader',
  componentName: 'ChatBotHeader',
  computed: {
  },
  props: {
    isArchiveList: {
      type: Boolean,
      require: true
    },
    roboNum: {
      type: Number,
      require: true
    },
    plan: {
      type: Number,
      require: true
    },
    companyID: {
      type: String,
      require: true
    }
  },
  data () {
    return {
      searchChatBotName: null,
      isArchiveListProp: this.isArchiveList
    }
  },
  computed: {
    isPlan () {
      if (this.companyID === '1dad12e572955a7fc7fbb820a0b30a79') {
        // 介護NEXT様用
        if ((this.plan === 1 && this.roboNum < 20) || this.plan > 1) {
          return true
        } else {
          return false
        }
      } else {
        if ((this.plan === 1 && this.roboNum < 10) || this.plan > 1) {
          return true
        } else {
          return false
        }
      }
    }
  },
  methods: {
    createChatBot () {
      this.$emit('createChatBot')
    },
    searchChatBot () {
      if (this.searchChatBotName) {
        this.$emit('searchChatBot', {
          flg: true,
          search: this.searchChatBotName
        })
      } else {
        this.$emit('searchChatBot', {
          flg: false,
          search: null
        })
      }
    },
    changeArchiveList (flg) {
      this.$emit('changeArchiveList', flg)
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.header-cb {
  margin: 10px 20px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
}
.header-cb > div {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ChatBotHeader.vue